import { DateTime } from "luxon";
import { epsDuJour, heureEp, nomSecteur, prochaineEp } from "../EP/calendrierEp";

// ============================================================
// Tableau de bord — résumés des indicateurs « Aujourd'hui » (fonctions pures).
// Chaque résumé rend { valeur, detail, ton } : la valeur est le nombre qui
// compte, le détail dit quoi en faire, le ton colore l'indicateur
// (ok = rien à faire, warn = une action attend, neutral = information).
// ============================================================

const jourCourt = (iso) => DateTime.fromISO(iso).toFormat("dd/MM");

export function resumeEpsDuJour(eps = [], sectors = [], maintenant = DateTime.local()) {
  const actives = eps.filter((ep) => !ep.cancelledAt);
  const duJour = epsDuJour(actives, maintenant);
  if (duJour.length) {
    const premiere = duJour[0];
    return {
      valeur: duJour.length,
      detail: `Première à ${heureEp(premiere)} · secteur ${nomSecteur(sectors, premiere.sector)}`,
      ton: "neutral",
    };
  }
  const prochaine = prochaineEp(actives, maintenant);
  return {
    valeur: 0,
    detail: prochaine
      ? `Prochaine le ${jourCourt(prochaine.beginAt)} à ${heureEp(prochaine)} · secteur ${nomSecteur(sectors, prochaine.sector)}`
      : "Aucune EP planifiée cette année",
    ton: "ok",
  };
}

// Invitations au jury en attente de réponse, pour des EP à venir (une EP
// passée n'attend plus de réponse).
export function resumeInvitations(invitations = [], maintenant = DateTime.local()) {
  const enAttente = invitations
    .filter(
      (i) =>
        i.invitationStatus === "WAITING" && i.EP && DateTime.fromISO(i.EP.beginAt).endOf("day") >= maintenant
    )
    .sort((a, b) => DateTime.fromISO(a.EP.beginAt).toMillis() - DateTime.fromISO(b.EP.beginAt).toMillis());
  if (!enAttente.length) {
    return { valeur: 0, detail: "Aucune réponse attendue", ton: "ok" };
  }
  const prochaine = enAttente[0].EP;
  return {
    valeur: enAttente.length,
    detail: `Prochaine EP le ${jourCourt(prochaine.beginAt)} · secteur ${nomSecteur([], prochaine.sector)}`,
    ton: "warn",
  };
}

export function resumeAnomalies(anomalies = []) {
  const ouvertes = (Array.isArray(anomalies) ? anomalies : []).filter((a) => a.status !== "DONE");
  return {
    valeur: ouvertes.length,
    detail: ouvertes.length ? "qui vous sont assignées" : "Rien à traiter",
    ton: ouvertes.length ? "warn" : "ok",
  };
}

export function resumeReorientations(reponse = {}) {
  const total = Number(reponse && reponse.count) || 0;
  return {
    valeur: total,
    detail: total ? "entre organismes, non terminées" : "Aucune réorientation en cours",
    ton: total ? "neutral" : "ok",
  };
}
